/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_12_P1Inputs */

const en_terms_section_12_p1 = /** @type {(inputs: Terms_Section_12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If anything here needs explaining, write to us:`)
};

const lv_terms_section_12_p1 = /** @type {(inputs: Terms_Section_12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja kaut kas šeit prasa skaidrojumu, rakstiet mums:`)
};

/**
* | output |
* | --- |
* | "If anything here needs explaining, write to us:" |
*
* @param {Terms_Section_12_P1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_12_p1 = /** @type {((inputs?: Terms_Section_12_P1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_12_P1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_12_p1(inputs)
	return en_terms_section_12_p1(inputs)
});